export default class SideMenuOverlay {
  constructor(scene, registryName) {
    this.scene = scene;
    // this.overlay = this.scene.add.rectangle(0, 0, 0, 0, 0x000000)
    this.overlay = this.scene.add.rectangle(0, 0, 0, 0, 0x000000);
    this.overlay.setAlpha(0.01).setVisible(false);
    this.overlay.setDepth(100);
    this.registryName = registryName;
  }
  show() {
    this.scene.changeObjectsInteractivity(false);
    this.overlay.setX(
      this.scene.getVisitedTableGameIndex() * this.overlay.width
    );
    if (!this.overlay.visible) this.overlay.setVisible(true);
    // this.scene.tweens.add({
    //     targets: this.overlay,
    //     duration: 300,
    //     ease: 'Linear',
    //     alpha: 0.5,
    //     onComplete: () => {
    //     }
    // });
  }
  hide() {
    this.scene.registry.set(this.registryName, false);
    if (this.overlay.visible) this.overlay.setVisible(false);
    this.scene.changeObjectsInteractivity(true);
    // this.scene.tweens.add({
    //     targets: this.overlay,
    //     duration: 30,
    //     ease: 'Linear',
    //     alpha: 0,
    //     onComplete: () => {
    //
    //     }
    // });
  }
  positionControls() {
    const self = this;
    this.overlay.width = this.scene.gameWidth;
    this.overlay.height = this.scene.gameHeight;
    this.overlay.setPosition(
      this.scene.getVisitedTableGameIndex() * this.overlay.width,
      0
    );

    this.overlay.setInteractive(
      new Phaser.Geom.Rectangle(
        0,
        0,
        this.overlay.displayWidth,
        this.overlay.displayHeight
      ),
      Phaser.Geom.Rectangle.Contains
    );
    this.overlay.on("pointerdown", (e) => {
      if (e.downElement.nodeName !== "CANVAS") {
        return false;
      }
      self.hide();
    });
  }
  reposition() {
    this.overlay.width = this.scene.gameWidth;
    this.overlay.height = this.scene.gameHeight;
    this.overlay.setPosition(
      this.scene.getVisitedTableGameIndex() * this.overlay.width,
      0
    );
  }
}
